/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type RouteAnnonsApproachKindEnum =
  (typeof RouteAnnonsApproachKindEnum)[keyof typeof RouteAnnonsApproachKindEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RouteAnnonsApproachKindEnum = {
  AtLogisticsCenter: 0,
  Filler: 1,
  PersonalTransport: 2,
} as const;
